import React from "react";
import { Box, BoxProps } from "./Box";

export interface StackProps extends BoxProps {
 direction?: "row" | "column";
 spacing?: "none" | "xs" | "sm" | "md" | "lg" | "xl";
 align?: "start" | "center" | "end" | "stretch";
 justify?: "start" | "center" | "end" | "between" | "around" | "evenly";
}

const spacingClasses = {
 none: "gap-0",
 xs: "gap-1",
 sm: "gap-2",
 md: "gap-4",
 lg: "gap-6",
 xl: "gap-8",
};

const alignClasses = {
 start: "items-start",
 center: "items-center",
 end: "items-end",
 stretch: "items-stretch",
};

const justifyClasses = {
 start: "justify-start",
 center: "justify-center",
 end: "justify-end",
 between: "justify-between",
 around: "justify-around",
 evenly: "justify-evenly",
};

export const Stack: React.FC<StackProps> = ({
 direction = "column",
 spacing = "md",
 align = "stretch",
 justify = "start",
 className = "",
 children,
 ...props
}) => {
 const flexDirection = direction === "row" ? "flex-row" : "flex-col";
 return (
  <Box
   className={`flex ${flexDirection} ${spacingClasses[spacing]} ${alignClasses[align]} ${justifyClasses[justify]} ${className}`}
   {...props}
  >
   {children}
  </Box>
 );
};

export default Stack;

